module.exports = __webpack_public_path__ + "static/headerBg.f3ec1366.svg";


//////////////////
// WEBPACK FOOTER
// /www/client/src/components/ConnectionPage/headerBg.svg
// module id = 801
// module chunks = 0